<template>
  <ubi-panel :full-width="browserContext.up('lg')">

    <social-review-answer-review-modal :textAnswer="textAnswer" :alreadyAnswered="alreadyAnswered"></social-review-answer-review-modal>

    <ubi-list-header slot="header"
                     :limits="limits"
                     :total="socialReviews.pagination.total"
                     :page.sync="page"
                     :limit.sync="limit"></ubi-list-header>
    <ubi-list-footer
        slot="footer"
        v-if="socialReviews.pagination.total && socialReviews.pagination.total > 1"
        :limits="limits"
        :total="socialReviews.pagination.total"
        :page.sync="page"
        :limit.sync="limit"
    ></ubi-list-footer>

    <el-table ref="table"
              v-if="socialReviews"
              :data="socialReviews.list"
              v-loading="loadingStatus"
              style="width: 100%"
    >

      <el-table-column type="expand">
        <template v-slot="{ row: result }">
          <div v-if="result.answerReview">
            <p>{{ $t('socialReviews.modal.messageModal') }} {{result.answerReview.date | moment('DD/MM/YYYY')}}</p>
            <p>{{ result.answerReview.comment }}</p>
          </div>
          <div v-else class="text-answerMessage-not-answer">{{ $t('socialReviews.table.messageAnswer') }}</div>
        </template>
      </el-table-column>

      <el-table-column
          min-width="400">
        <template v-slot="{ row: result }">
          <el-row>

            <el-col style="text-align: center; padding-top: 15px;" :lg="2">
              <img
                  :alt="result.media.name"
                  :src="require(`@/assets/google-logo-carre.png`)"
                  width="40"
                  v-if="filterMediaByNetwork(result, 'Google')"
              />
              <img
                  alt=""
                  :src="require(`@/assets/facebook-logo-5-1.png`)"
                  width="40"
                  v-if="filterMediaByNetwork(result, 'Facebook')"
              />
            </el-col>
            <el-col :lg="22" style="padding-left: 20px;">
              <div><strong>{{ result.poi.name }}</strong></div>
              <div><span v-html="drawNote(result.note)" /></div>
              <div class="container-content-card-reviews"><p class="content-card-reviews">{{ result.text }}</p></div>
              <div>{{ result.author }}</div>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column
          min-width="250"
          align="right">
        <template v-slot="{ row: result }">
          <div style="text-align: right">{{ $t('socialReviews.export.dateOfPublication') }} : {{ result.publicationDate | moment('DD/MM/YYYY')}}</div>
          <div style="text-align: right">{{ $t('socialReviews.search.detectionDate') }} : {{ result.detectionDate | moment('DD/MM/YYYY') }}</div>
          <div>&nbsp;</div>
          <div style="text-align: right">
            <el-tooltip class="item" effect="dark" :content="$t('socialReviews.modal.messageModal')" placement="top-start" v-if="result.answerReview">
              <el-button size="mini" @click="displayModalAnswer(result.id, result)"><img
                  :src="require(`@/assets/icone-de-coche-verte.png`)"
                  width="15"
                  style="padding-bottom: 3px; padding-right: 5px"
              /> {{ $t('socialReviews.search.answered') }}</el-button>
            </el-tooltip>
            <el-button size="mini" @click="displayModalAnswer(result.id, result)" v-else>{{ $t('socialReviews.search.toAnswer') }}</el-button></div>
        </template>
      </el-table-column>
    </el-table>
  </ubi-panel>
</template>
<script>
import UbiPanel from '@/components/Panel'
import { mapMutations, mapState } from 'vuex'
import SocialReviewAnswerReviewModal from '@/pages/SocialReviews/Blocks/SocialReviewAnswerReviewModal'
export default {
  inject: ['browserContext'],
  components: { UbiPanel, SocialReviewAnswerReviewModal },
  data () {
    return {
      limits: [20],
      textAnswer: '',
      alreadyAnswered: false
    }
  },
  computed: {
    ...mapState('socialReviewsList', ['filters', 'socialReviews', 'loadingStatus']),
    page: {
      get () {
        return this.filters.page
      },
      set (value) {
        this.setPage(value)
        this.$store.dispatch('socialReviewsList/loadSocialReviews')
      }
    },
    limit: {
      get () {
        return this.filters.limit
      },
      set (value) {
        this.setLimit(value)
        this.setPage(1)
        this.$store.dispatch('socialReviewsList/loadSocialReviews')
      }
    },
  },
  methods: {
    ...mapMutations('socialReviewsList', [
      'setPage',
      'setSocialReviews',
      'setLimit'
    ]),
    filterMediaByNetwork (post, searchName) {
      if (post && post.media.name) {
        return post.media.name.includes(searchName)
      }
      if (post && post.media.code) {
        const codeName = post.media.code.split('_')[0]
        return codeName.toLowerCase() === searchName.toLowerCase()
      }
    },
    drawNote (note) {
      let strStars = ''
      let i = 1
      for (i; i <= note; i++) {
        // do something
        strStars = strStars + '&#11088;'
      }
      return strStars
    },
    displayModalAnswer (id, result) {
      this.$store.commit('socialReviewsList/setIdReviewToAnswer', id)
      this.$store.commit('socialReviewsList/setCurrentReview', result)
      this.$store.commit('socialReviewsList/setModalResponse', true)
      if (result.answerReview && result.answerReview.comment) {
        this.$store.commit('socialReviewsList/setTextAnswer', result.answerReview.comment)
      } else {
        this.$store.commit('socialReviewsList/setTextAnswer', '')
      }
    }
  },
  mounted () {
    this.$store.dispatch('socialReviewsList/loadSocialReviews')
  }
}
</script>

<style scoped>
.text-answerMessage-not-answer{
  color: #00b4cc;
}

.content-card-reviews {
  word-break: break-word;
  white-space: normal;
}
</style>
